<template>
  <b-container fluid class="picture">
    <b-container>
      <b-row>
        <b-col>
          <h3 class="animated wow zoomIn">Zobacz nasze urządzenia w akcji na materiale filmowym</h3>
          <button class="btn btn-lg btn-primary text-uppercase animated wow bounceIn" data-wow-delay="1s">Więcej</button>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: 'Picture',
  components: {}
}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import 'node_modules/bootstrap/scss/variables';
// @import "variables";

.picture{
  background: url('./../assets/picture.jpg');
  background-size: cover;
  color: white;
  text-align: center;
  padding: 100px 0;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    padding: 50px 0;
  }
}
.picture h3{
  font-size: 60px;
  max-width: 80%;
  font-weight: bold;
  margin: 15px auto 30px;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    font-size: 36px;
    max-width: 90%;
  }
}
.picture .btn{
  padding:10px 30px;
  font-weight: normal;
}
</style>